export default __webpack_public_path__ + "static/media/email.4ce2abe1.svg";